import React, { Fragment } from "react";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
// import "./drawer/AdaptiveDrawer.css";

function AuthorizedOnly(props) {
  let { privileges = [] } = props;
  let { hasAnyPrivilege } = props.context;
  if (hasAnyPrivilege(privileges)) {
    return <Fragment>{props.children}</Fragment>;
  }

  return null;
}

export default withSharedStateConsumer(AuthorizedOnly);
